import React, { useState, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';

import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import imagePlaceholder from '../../assets/Images/image 17.png';
import addFingerprint from '../../assets/icons/FingerPrint.svg';
import { PhotoEditor } from '../PhotoEditor';
import { Postdata } from '../../API/GlobalApi';
import Notifier from '../../Utils/notify';

export const CaptureBiometricThumb = ({ isOpen, onClose, setpaymentmodal, selectedOrgDetails, capturedPhoto, setCapturedPhoto, setShowEditor, fingerprints, setFingerprints, setimgurl, setidcardmodal, idcarddata, setidcarddata, refreshStudents, currentPage }) => {
    const [showToast, setShowToast] = useState(false);
    const [toastVariant, setToastVariant] = useState('success');
    const [toastMessage, setToastMessage] = useState('');

    const webcamRef = useRef(null);
    const [showCamera, setShowCamera] = useState(false);

    

    const displayToast = (message, variant = 'success') => {
        setToastMessage(message);
        setToastVariant(variant);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };




    const getSafe = (val) => val || "N/A";

    const captureFingerprint = async (index) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", "http://localhost:8367/bioenable/capture", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                console.log("xhr====", data)

                setFingerprints(prev => {
                    const updated = [...prev];
                    // Store both IsoTemplate and BitmapData if available
                    updated[index] = {
                        IsoTemplate: data.IsoTemplate || null, // optional for backend
                        BitmapData: data.BitmapData || null    // for UI
                    };
                    return updated;
                });
            } else if (xhr.readyState === 4) {
                console.log("xhr i n below====", xhr)
                Notifier.error(`Capture error, ${xhr.status}, ${xhr.responseText}`);
            }
        };
        xhr.send(JSON.stringify({
            Quality: 60,
            TimeOut: 10,
            TemplateRequired: true,
            TemplateFormat: "ISO",
            ImageRequired: true
        }));
    };


    const handleSubmit = async () => {
        if (!fingerprints.some(fp => fp)) {
            Notifier.error("Please capture at least one fingerprint");
            return;
        }

        const payload = {
            student: selectedOrgDetails?.user_id,
            finger_iso_1: fingerprints[0]?.BitmapData || "",
            finger_iso_2: fingerprints[1]?.BitmapData || "",
            finger_iso_3: fingerprints[2]?.BitmapData || ""
        };

        try {
            const res = await Postdata("students/students-attendance/", payload);

            if (!res?.error) {
                Notifier.success("Biometric registered successfully");
                onClose();                // close modal
                refreshStudents({ page: currentPage }); // ✅ REFRESH STUDENTS LIST

            } else {
                Notifier.error(res?.message || "Failed to save biometric");
            }
        } catch (err) {
            Notifier.error("Server error while saving biometric");
        }
    };





    const hasExistingBiometric =
        !!idcarddata?.finger_iso_1 ||
        !!idcarddata?.finger_iso_2 ||
        !!idcarddata?.finger_iso_3;
    // Initialize fingerprints from idcarddata
    useEffect(() => {
        if (idcarddata) {
            setFingerprints(prev => {
                // keep any already captured thumbs
                if (prev?.some(fp => fp?.BitmapData)) return prev;

                return [
                    idcarddata.finger_iso_1 ? { IsoTemplate: idcarddata.finger_iso_1, BitmapData: null } : null,
                    idcarddata.finger_iso_2 ? { IsoTemplate: idcarddata.finger_iso_2, BitmapData: null } : null,
                    idcarddata.finger_iso_3 ? { IsoTemplate: idcarddata.finger_iso_3, BitmapData: null } : null
                ];
            });
        }
    }, [idcarddata, isOpen]);



    if (!isOpen) return null;
    const hasAtLeastOneFingerprint = fingerprints.some(fp => fp !== null);

    return (
        <>
            <div className="modal-overlay">
                <div className="modal-content" style={{ position: 'relative', width: '35%', maxHeight: '95vh' }}>
                    <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='text-primary'>{hasExistingBiometric ? "Biometric completed" : "Biometric registration"}</h2>
                        <button className="close-btn" onClick={() => { onClose(); setCapturedPhoto() }}><img src={close} alt="close" /></button>
                    </div>

                    <div className="modal-body" style={{ overflow: 'unset' }} >
                        {/* <div className="row" style={{ background: '#F9FAFC', padding: "10px" }}> */}

                        {/* </div> */}



                        <h4 className='fm-pr-hd'>   {hasExistingBiometric ? '' : 'ADD BIOMETRIC'}</h4>

                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px', justifyContent: 'center' }}>
                            {fingerprints.map((fp, index) => {
                                const label = fp?.BitmapData ? 'Captured' : fp?.IsoTemplate ? 'Registered' : 'Add Fingerprint';
                                const isRegistered = fp?.IsoTemplate && !fp?.BitmapData;

                                return (
                                    <div key={index} style={{ textAlign: 'center' }}>
                                        <div
                                            onClick={() => !hasExistingBiometric && captureFingerprint(index)}
                                            style={{
                                                width: 60,
                                                height: 60,
                                                borderRadius: 6,
                                                border: '1px solid #ccc',
                                                backgroundColor: '#f2f2f2',
                                                cursor: hasExistingBiometric ? 'default' : 'pointer',
                                                opacity: isRegistered ? 0.6 : 1
                                            }}
                                            title={isRegistered ? 'Fingerprint registered' : 'Click to capture fingerprint'}
                                        >
                                            {fp?.BitmapData ? (
                                                <img
                                                    src={`data:image/bmp;base64,${fp.BitmapData}`}
                                                    alt={`Fingerprint ${index + 1}`}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <img
                                                    src={addFingerprint}
                                                    alt={label}
                                                    style={{ width: '100%', height: '100%' }}
                                                />
                                            )}
                                        </div>
                                        <p style={{ marginTop: 5, fontSize: 12 }}>{label}</p>
                                    </div>
                                );
                            })}


                        </div>

                    </div>


                    {!hasExistingBiometric && (
                        <div className="form-actions" style={{ background: 'white', display: 'flex', justifyContent: 'end' }}>
                            <button
                                type="submit"
                                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                                onClick={handleSubmit}
                            >
                                Submit
                                <img src={next} alt="next" />
                            </button>
                        </div>
                    )}





                </div>
            </div>


        </>

    );
};
